import { render, staticRenderFns } from "./LevelFormulaNotice.vue?vue&type=template&id=4c21f3d4&scoped=true"
import script from "./LevelFormulaNotice.vue?vue&type=script&lang=js"
export * from "./LevelFormulaNotice.vue?vue&type=script&lang=js"
import style0 from "./LevelFormulaNotice.vue?vue&type=style&index=0&id=4c21f3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c21f3d4",
  null
  
)

export default component.exports